import $ from 'jquery';
import slick from 'slick-carousel';

const Slider = {
    bindEvents: () => {

        const SlideContainer = $('.sib-slider__cards');
        const StatisticsContainer = $('.sib-statistics__cards');
        const ImageContainer = $('.sib-image-slider__wrapper');
        const RelatedArticles = $('.sib-lists__cards');

        if (ImageContainer) {
            ImageContainer.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: true,
                centerPadding: '60px',

            });
        }

        if (RelatedArticles) {
            RelatedArticles.slick({
                autoplay: false,
                infinite: false,
                speed: 500,
                autoplaySpeed: 500,
                slidesToShow: 4,
                variableWidth: true,
                cssEase: 'linear',
                nextArrow: '',
                prevArrow: '',
                respondTo: 'min'
            });
        }

        if (StatisticsContainer) {
            StatisticsContainer.slick({
                autoplay: false,
                speed: 500,
                infinite: false,
                autoplaySpeed: 500,
                slidesToShow: 3,
                variableWidth: true,
                cssEase: 'linear',
                nextArrow: '',
                prevArrow: '',
                respondTo: 'min'
            });
        }

        if (SlideContainer) {
            SlideContainer.slick({
                autoplay: false,
                infinite: false,
                speed: 500,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear',
                nextArrow: '',
                prevArrow: ''
            });
        }

        $('.sib-card-slider__slick-button--forward').on('click', function () {
            $('.sib-slider__cards').slick('slickNext');
        });

        $('.sib-card-slider__slick-button--back').on('click', function () {
            $('.sib-slider__cards').slick('slickPrev');
        });


    },
};

module.exports = Slider;



// WEBPACK FOOTER //
// ./src/js/partials/slider.js